import { SET_FINANCIAL_CALCULATOR_DATA } from "./mutations";
import _ from "lodash";

const setFinancialCalculatorData = (payload) => ({
  type: SET_FINANCIAL_CALCULATOR_DATA,
  payload,
});

export { setFinancialCalculatorData };
